var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#fff",
    height: 512,
    viewBox: "0 0 100 100",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.007 95c1.387 0 2.807-.008 4.258-.008h27.467c1.449 0 2.869.008 4.256.008 12.709 0 22.42-.65 22.42-13.936 0-13.906-10.635-25.322-24.217-26.563-.108 4.865-16.188 16.871-16.188 16.871s-16.084-12.005-16.193-16.87c-13.58 1.24-24.217 12.656-24.217 26.562 0 13.286 9.707 13.936 22.414 13.936zm29.993-18.143c0-.396.357-.715.801-.715h4.344v-4.342c0-.44.317-.801.713-.801h4.287c.394 0 .713.358.713.801v4.343h4.342c.44 0 .8.319.8.715v4.285c0 .396-.357.715-.8.715h-4.343v4.342c0 .442-.32.8-.715.8h-4.285c-.396 0-.715-.357-.715-.8v-4.343h-4.342c-.442 0-.801-.319-.801-.715z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.008 57.992c12.284 0 22.241-18.471 22.241-30.754 0-12.281-9.957-22.238-22.241-22.238-12.282 0-22.239 9.957-22.239 22.238 0 12.283 9.957 30.754 22.239 30.754z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.9ad0e10788ca4084f101eb3213442df2.svg";
export { ForwardRef as ReactComponent };